const GetWorkerType = (user) => {
  if (!user) return "Operativa";
  const area = user.area?.toUpperCase();
  if (area === "ADMINISTRACION") return "Administrativo";
  if (area === "COMERCIAL") return "Comercial";
  if (area === "MARKETING") return "Operativa";
  if (area === "SOFTWARE") return "Operativa";
  return "Operativa";
}

export default GetWorkerType;

// Areas

// Administracion
// Comercial
// Marketing
// Software